















































































import { Component, Ref, Vue } from "vue-property-decorator";
import { FormBuilder, Form } from "vue-formio";
import { Templates } from "formiojs";
import "formiojs/dist/formio.full.css";
import { IInputArgument, IRelease } from "@/interfaces/orchestrator.interface";
import API from "../store/api";
import { getRouteByName, ROUTE_NAMES, WithRoute } from "@/router"
import { IProcessForm } from "@/interfaces/process-form.interface";
import { PUBLIC_PATH } from "@/config"

Templates.framework = "bootstrap";

// Part of the monkey-patch to not overwrite the component keys
function fastCloneDeep(obj: any) {
  return obj ? JSON.parse(JSON.stringify(obj)) : obj;
}

function emptyProcessForm(): IProcessForm {
  return {
    id: undefined as any,
    organization: undefined as any,
    releaseId: undefined as any,
    form: {}
  };
}

@Component({
  components: { FormBuilder, Form }
})
export default class ProcessFormBuilderView extends Vue implements WithRoute {
  loading: boolean = false;
  error: boolean = false;
  showTestFormDialog: boolean = false;
  processFormLink: string = "";

  @Ref("builder") builder!: FormBuilder;
  processForm: IProcessForm = emptyProcessForm();

  release: IRelease | null = null;

  acknowledgeError(): void {
    this.error = false;
  }

  get formUrl(): string {
    return window.location.href.replace("formbuilder", "form");
  }

  testForm() {
    this.showTestFormDialog = true;
  }

  async saveForm() {
    this.processForm.releaseId =
      this.processForm.releaseId || this.$route.params.releaseId;
    const processForm: IProcessForm | null = await API.saveUiPathProcessForm(
      this.processForm
    );
    if (processForm && processForm.id) {
      this.processForm = processForm;
    } else {
      alert(
        "Beim Speichern ist ein Fehler aufgetreten, bitte versuchen Sie es erneut oder kontaktieren Sie ihren Administrator."
      );
    }
  }

  async onSubmitTestForm(e: any) {
    delete e.data.submit;
    const inputArguments = JSON.stringify(e.data);
    const result = await API.startNewJob(this.release!.Key, inputArguments, this.release!.OrganisationalUnitId);
  }

  onSaveComponent(e: any) {
    // console.log(arguments);
  }

  async mounted() {
    this.loading = true;

    const releaseId: string = this.$route.params.releaseId;
    this.processForm = await API.getUiPathProcessFormByReleaseId(releaseId) || emptyProcessForm();
    // TODO why do we need to load all releases again
    //  and not just use the data loaded from orchestratorReleasesView.vue
    this.release = await API.getOrchestratorRelease(parseInt(releaseId));

    this.loading = false;

    setTimeout(() => {
      if (this.builder) {
        const webFormBuilderClass = Object.getPrototypeOf(
          this.builder.builder.instance
        );

        webFormBuilderClass.getComponentInfo = function(key: any, group: any) {
          let info;
          // This is a new component
          if (this.schemas.hasOwnProperty(key)) {
            info = fastCloneDeep(this.schemas[key]);
          } else if (this.groups.hasOwnProperty(group)) {
            const groupComponents = this.groups[group].components;
            if (groupComponents.hasOwnProperty(key)) {
              info = fastCloneDeep(groupComponents[key].schema);
            }
          }
          if (group.slice(0, group.indexOf("-")) === "resource") {
            // This is an existing resource field.
            const resourceGroups = this.groups.resource.subgroups;
            const resourceGroup = resourceGroups.find(
              (group: any) => group.key === group
            );
            if (resourceGroup && resourceGroup.components.hasOwnProperty(key)) {
              info = fastCloneDeep(resourceGroup.components[key].schema);
            }
          }

          if (info) {
            info.key =
              info.key ||
              info.title ||
              info.label ||
              info.placeholder ||
              info.type;
          }

          return info;
        };
      }
    }, 500);
  }

  get options() {
    const componentsMap: any = {};

    if (this.release != null && this.release.Arguments.Input) {
      const componentsList = this.release.Arguments.Input.map(
        this.argumentToInputOption
      ).flat();
      componentsList.forEach(component => {
        componentsMap[component.key] = component;
      });
    }

    return {
      language: "de",
      i18n: {
        de: {
          Submit: "Ausführen",
          "Basic Components": "Standard Komponenten",
          "Drag and Drop a form component":
            "Formular-Elemente hier durch Ziehen platzieren.",
          "Process-Specific Elements": "Prozess-Spezifische Elemente",
          Save: "Speichern",
          Cancel: "Abbrechen",
          Remove: "Entfernen"
        }
      },
      builder: {
        basic: {
          default: false
        },
        premium: false,
        custom: {
          title: "Process-Specific Elements",
          default: true,
          weight: 10,
          components: componentsMap
        },
        layout: {
          components: {
            table: false
          }
        }
      },
      editForm: {
        textfield: [
          {
            key: "api",
            ignore: false
          }
        ]
      }
    };
  }

  argumentToInputOption(argument: IInputArgument) {
    const name = argument.name.startsWith("in_")
      ? argument.name.substr(3)
      : argument.name;
    // "camelCase" to "Start Case"
    const label = this.toStartCase(name);
    let options: any = {};
    let icon: string = "terminal";
    const argumentType: string = argument.type;

    if (argumentType.startsWith("System.String,")) {
      options = { type: "textfield" };
      icon = "font";
    } else if (argumentType.startsWith("System.Boolean,")) {
      options = { type: "checkbox" };
      icon = "check-square";
    } else if (
      argumentType.includes("[],") ||
      argumentType.startsWith("System.Collections.Generic.List`1[[")
    ) {
      options = { multiple: true, type: "textfield" };
      if (argumentType.includes("System.String")) {
        options.type = "textfield";
      } else if (argumentType.includes("System.Int32")) {
        options.type = "number";
      } else if (argumentType.includes("System.Double")) {
        options.type = "number";
        options.decimalLimit = 4;
      }
      icon = "th-list";
    } else if (argumentType.startsWith("System.Int32,")) {
      options = { type: "number" };
      icon = "hashtag";
    } else if (argumentType.startsWith("System.Double,")) {
      options = { type: "number", decimalLimit: 4 };
      icon = "hashtag";
    } else {
      options = { type: "textarea" };
    }

    if (!options.multiple) {
      return [
        {
          title: label,
          key: argument.name,
          icon,
          schema: {
            label: label,
            key: argument.name,
            input: true,
            ...options
          }
        }
      ];
    } else {
      const options2 = {
        type: "select",
        placeholder: "",
        template: "{{ item.label }}",
        multiple: true,
        dataType: "auto",
        dataSrc: "values",
        data: {
          values: [
            {
              label: "",
              value: ""
            }
          ]
        }
      };
      return [
        {
          title: label,
          key: argument.name,
          icon,
          schema: {
            label: label,
            key: argument.name,
            input: true,
            ...options
          }
        },
        {
          title: label + " as Select",
          key: argument.name + "AsSelect",
          icon,
          schema: {
            label: label,
            key: argument.name,
            input: true,
            ...options2
          }
        }
      ];
    }
  }

  toStartCase(input: string) {
    let result = input
      .replace(/([A-Z]+)/g, " $1")
      .replace(/([A-Z][a-z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
  }

  async generateLink() {
    let result: string | null = await API.generateProcessFromLink(this.processForm.id);
    if(result === null) {
      this.error = true;
    } else {
      this.processFormLink = result;
    }
  }
}
